import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref } from 'vue'
  import { Toast, Dialog } from 'vant'
  import { useRouter } from 'vue-router'
  import wx from 'weixin-js-sdk'

  import { getUserActivityP150, receivingUserActivityP150 } from '@/apis/activity'
  import type { IP150PaddleItem } from '@/types/activity'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const $router = useRouter()

  const loading = ref(false)
  const p150List = ref<IP150PaddleItem[]>([])
  const p150ListItem = ref<IP150PaddleItem>()

  const ListName = 'activity-p150-paddle-gifts-list';
  const InputSnName = 'activity-p150-paddle-gifts-sn';
  const ProtocName = 'activity-p150-paddle-gifts-protoc';

  async function fetchData() {
    let data = await getUserActivityP150()
      // // 模拟数据
      // if (data.length === 0) {
      //   data = [
      //     {
      //       "name": "黑匣子V2成品1",
      //       "serial_number": "DL1B110025",
      //       "is_receiving": false
      //     },
      //     {
      //       "name": "黑匣子V2成品2",
      //       "serial_number": "DL1B110026",
      //       "is_receiving": false
      //     },
      //     {
      //       "name": "黑匣子V2成品3",
      //       "serial_number": "DL1B110027",
      //       "is_receiving": true
      //     },
      //     {
      //       "name": "黑匣子V2成品4",
      //       "serial_number": "DL1B110028",
      //       "is_receiving": false
      //     },
      //     {
      //       "name": "黑匣子V2成品5",
      //       "serial_number": "DL1B110029",
      //       "is_receiving": true
      //     },
      //     {
      //       "name": "黑匣子V2成品7",
      //       "serial_number": "DL1B110002",
      //       "is_receiving": true
      //     },
      //     {
      //       "name": "黑匣子V2成品7",
      //       "serial_number": "DL1B110003",
      //       "is_receiving": true
      //     }
      //   ]
      // }
      p150List.value = data;
  }

  async function initData() {
    try {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      await fetchData();
      Toast.clear()
    } catch (e) {
      Toast.fail(e)
      console.log(e)
    }
    loading.value = false;
  }

  initData();

  async function checkSn(sn:string) {
    try {
      Toast.loading({
        message: '检查中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      const res = await receivingUserActivityP150(sn, p150ListItem.value.serial_number);
      Toast.clear()
      Dialog.alert({
        title: '提示',
        message: '领取成功！',
        confirmButtonColor: '#03C280',
        confirmButtonText: '知道了',
      })
      fetchData();
      return true;
    } catch (error) {
      Toast.fail(error)
      return false;
    }
  }

  const onCheckInputSn = async (sn:string) =>{
    const res = await checkSn(sn);
    if(res){
      $router.replace({
        name: ListName,
      })
    }
  }

  const onAction = (data: {
    action: string,
    item: IP150PaddleItem
  }) => {
    p150ListItem.value = data.item;
    if (data.action === 'scan') {
      wx.scanQRCode({
        needResult: 1,
        scanType: ['barCode', 'qrCode', 'datamatrix'],
        success: function (res: { resultStr: string }): void {
          console.log('resultStr', res)
          const sn = res.resultStr?.split(',')?.pop() || ''
          checkSn(sn)
        }
      })
    } else {
      $router.push({
        name: InputSnName,
      })
    }
  }

  function gotoProtoc() {
    console.log('gotoProtoc')
    $router.push({
      name: ProtocName,
      query: {
        title: '桨叶外包装盒序列号',
        url: 'https://release-platform.xa.com/app_view_page/help_doc/d2227d29-3bd3-4270-881a-bbd98e895fea',
      },
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_KeepAlive, null, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          list: p150List.value,
          onAction: onAction,
          onSubmitSn: onCheckInputSn,
          onProtoc: gotoProtoc
        }, null, 40, ["list"]))
      ], 1024))
    ]),
    _: 1
  }))
}
}

})